export default {
  Completed: 1,
  NotCompleted: 0,
};
